<template>
  <div id="pageRoot">
	<div class="enciclopedia">
	<p class="textBaseCourier" id="text02">
		LAS CHICHARRAS
	</p>
	<p class="textBaseCourier" style="
	position: absolute;
	width: 430px;
	height: 133px;
	left: 44px;
	top: 189px;

	font-size: 22px;
	line-height: 33px;"
	>
		Las cigarras o chicharras son otra clase de instectos. Se destacan por emitir sonido los días de calor. Al igual que el de los grillos, no se trata de un verdadero canto. Las cigarras consiguen sus sonidos haciendo vibrar un órgano que tienen en el abdomen. Solo los machos cantan y lo hacen para atraer a las hembras  en la época de apareamiento, en pleno verano.
	</p>

	<img src="/pages/img/sordovio/assets_p33/chicharra.png"  style="
	position: absolute;
	width: 330px;
	left: 502px;
	top: 128px;">

	<img src="/pages/img/sordovio/assets_p33/zorrito.svg"  style="
	position: absolute;
	width: 600px;
	left: 520px;
	top: 400px;">

	<p class="textBaseCourier" style="
	position: absolute;
	width: 430px;
	height: 133px;
	left: 44px;
	top: 650px;

	font-size: 22px;
	line-height: 33px;"
	>
		*Texto adaptado para este cuaderno.
	</p>

	</div>
  </div>
</template>
<style scoped>
#text02
{
position: absolute;
width: 848px;
height: 51px;
left: 40px;
top: 128px;

font-weight: bold;
font-size: 47px;
line-height: 53px;

color: #231F20;
}
#text03
{
position: absolute;
width: 843px;
height: 133px;
left: 44px;
top: 189px;

font-size: 22px;
line-height: 33px;

color: #000000;
}
#text04
{
position: absolute;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text05
{
position: absolute;
width: 860px;
height: 198px;
left: 40px;
top: 543px;

font-size: 22px;
line-height: 33px;

color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 107.mp4", "vio/Video 108.mp4",]
    }
  }
}
</script>